import { Controller } from "stimulus";
import { chunkUrl, swapRange, failRange, claimRetry, onConflict, loadChunks } from "../../training_grooming_calendar/month_chunks";

const CONFLICT = 409;

export default class extends Controller {
  static targets = ["scroller"];
  static values = { url: String, ranges: Array, lanes: String, first: String };

  connect() {
    this.token = (this.token || 0) + 1;
    const root = this.element.closest(".tg") || this.element;
    const retry = claimRetry(root, this.urlValue);
    if (!this.element.closest("[data-tg-restoring]")) this.scrollToFirst();
    if (!this.element.querySelector(".tg-cell-skeleton")) return;
    const token = this.token;
    loadChunks({
      ranges: this.rangesValue,
      fetchRange: (range) => this.fetchRange(range),
      apply: (payload) => swapRange(this.element, payload),
      fail: (range) => failRange(this.element, range),
      stale: (left) =>
        onConflict({
          retry,
          root,
          key: this.urlValue,
          reload: () => this.element.dispatchEvent(new CustomEvent("training-grooming:reload", { bubbles: true })),
          fail: (range) => failRange(this.element, range),
          left,
        }),
      current: () => token === this.token && this.element.isConnected,
    });
  }

  disconnect() {
    this.token = (this.token || 0) + 1;
  }

  fetchRange(range) {
    return fetch(chunkUrl(this.urlValue, range, this.lanesValue), { headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }, credentials: "same-origin" }).then((response) => {
      if (response.status === CONFLICT) return { stale: true };
      if (!response.ok) throw new Error(`Request failed (${response.status})`);
      return response.json().then((payload) => ({ payload }));
    });
  }

  scrollToFirst() {
    if (!this.hasScrollerTarget || !this.firstValue) return;
    const head = this.scrollerTarget.querySelector(`.tg-week-day[data-date="${this.firstValue}"]`);
    const corner = this.scrollerTarget.querySelector(".tg-week-corner");
    if (!head || !corner) return;
    const offset = head.getBoundingClientRect().left - this.scrollerTarget.getBoundingClientRect().left - corner.getBoundingClientRect().width;
    this.scrollerTarget.scrollLeft += offset;
  }
}
